"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNotErrorSent = exports.setErrorInCache = void 0;
const FieldsLogsCache = {};
const setErrorInCache = (applicationSlug = "unknown", 
// eslint-disable-next-line @typescript-eslint/naming-convention
field_type) => {
    var _a;
    const fieldTypesCache = (_a = FieldsLogsCache[applicationSlug]) !== null && _a !== void 0 ? _a : new Set();
    fieldTypesCache.add(field_type);
    FieldsLogsCache[applicationSlug] = fieldTypesCache;
};
exports.setErrorInCache = setErrorInCache;
const isNotErrorSent = (applicationSlug = "unknown", 
// eslint-disable-next-line @typescript-eslint/naming-convention
field_type) => {
    var _a;
    return !((_a = FieldsLogsCache[applicationSlug]) === null || _a === void 0 ? void 0 : _a.has(field_type));
};
exports.isNotErrorSent = isNotErrorSent;
